import { Box, Container } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { FC, PropsWithChildren } from 'react';
import { NavBar } from 'src/components/NavBar';
import { TopBar } from 'src/components/TopBar';

import styles from './styles.module.css';

export const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const [opened, { toggle }] = useDisclosure(true);

  return (
    <Box className={styles.layout}>
      <TopBar opened={opened} toggle={toggle} />
      <Box className={styles.wrapper}>
        <NavBar opened={opened} />
        <Container fluid className={styles.container}>
          <div className={styles.content}>{children}</div>
        </Container>
      </Box>
    </Box>
  );
};
